<template>
  <div>
<!--    <FuncionalidadeHeader-->
<!--      :custom-voltar="true"-->
<!--      :titulo="titulo"-->
<!--      @click="voltar"-->
<!--    />-->
    <div id="tipo-solicitacao">
      <div
        v-if="mostrarFormulario"
      >
        <TemplateStepFormulario
          :data="minhaDataForm"
          :idFuncionalidade="idFuncionalidade"
          :step="myStep"
          :step-count="stepCount"
          :step-end="stepEnd"
          :beneficiarioSelecionado="beneficiarioSelecionado"
          @proximo="proximo"
        />
      </div>

      <div v-else>
        <el-row>
          <el-col
            :span="12"
            style="border-right: 1px solid #EEEEEE; padding-right: 25px;"
          >
            <div class="template-solicitacao-titulo">{{ tituloStep }}</div>
            <div class="template-solicitacao-descricao">{{ descricao }}</div>

            <div
              style="margin-bottom: 40px;"
            >
              <div class="tipo-solicitacao-label">Selecionar tipo</div>
              <el-radio-group
                v-model="assuntoSelecionado"
              >
                <el-radio
                  v-for="(elemento) in elementos"
                  :key="elemento.chave"
                  :label="elemento"
                  class="ms-radio"
                >
                  {{ elemento.assunto }}
                </el-radio>
              </el-radio-group>
            </div>

            <ButtonDefault
              :disabled="!assuntoSelecionado"
              style="height: 34px; width: 100%;"
              :title="ultimoStep"
              @click="abrirFormulario"
            />
          </el-col>
          <el-col
            :span="12"
            v-if="assuntoSelecionado && assuntoSelecionado.instrucoes"
          >
            <div
              style="padding-left: 25px;"
              v-html="assuntoSelecionado.instrucoes"
            />
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>
<script>
import ButtonDefault from '@/components/buttons/ButtonDefault'
import TemplateStepFormulario from '@/components/TemplateSolicitacao/steps/TemplateStepFormulario'

export default {
  name: 'TemplateStepTipoSolicitacao',
  components: { TemplateStepFormulario, ButtonDefault },
  props: {
    step: {
      type: Object
    },
    titulo: {
      type: String,
      default: ''
    },
    idFuncionalidade: {
      type: [Number, String],
      default: -23
    },
    data: {
      default: () => ({})
    },
    beneficiarioSelecionado: {
      type: Object,
      default: undefined
    },
    stepCount: {
      type: [Number, String],
      default: 1
    },
    stepEnd: {
      type: [Number, String],
      default: 1
    }
  },
  data () {
    return {
      assuntoSelecionado: null,
      mostrarFormulario: false
    }
  },
  computed: {
    elementos () {
      return this.step.solicitacaoTemplateTipo
    },
    tituloStep () {
      return this.step.titulo
    },
    descricao () {
      return this.step.descricao
    },
    myStep () {
      if (this.assuntoSelecionado.formulario) {
        return {
          instrucoes: this.assuntoSelecionado.instrucoes,
          titulo: this.assuntoSelecionado.formulario.titulo,
          descricao: this.assuntoSelecionado.formulario.descricao,
          formulario: this.assuntoSelecionado.formulario
        }
      }

      return {
        instrucoes: this.assuntoSelecionado.instrucoes,
        titulo: this.step.formulario.titulo,
        descricao: this.step.formulario.descricao,
        formulario: this.step.formulario
      }
    },
    minhaDataForm () {
      if (this.data.assunto) {
        if (this.data.assunto.chave !== this.assuntoSelecionado.chave) {
          return {
            assunto: this.data.assunto,
            formData: []
          }
        }
      }
      return this.data
    },
    ultimoStep () {
      let texto = 'PRÓXIMO'
      if (this.stepCount === this.stepEnd) {
        texto = 'ENVIAR'
      }
      return texto
    }
  },
  methods: {
    init () {
      this.assuntoSelecionado = this.data.assunto
      this.mostrarFormulario = !!this.data.formData

      // abre o formulário padrão
      if (this.elementos.length === 0 && !this.data.formData) {
        this.assuntoSelecionado = this.step
        this.mostrarFormulario = true
      }
    },
    abrirFormulario () {
      this.mostrarFormulario = true
    },
    proximo (formularioPayload) {
      const payloadStep = {
        assunto: this.assuntoSelecionado,
        formData: formularioPayload.formData
      }

      this.$emit('proximo', payloadStep)
    },
    voltar () {
      if (!this.mostrarFormulario) {
        this.$emit('voltar')
      } else {
        this.mostrarFormulario = false
      }
    }
  },
  mounted () {
    this.init()
  }
}
</script>
<style lang="postcss">
#tipo-solicitacao {
  .tipo-solicitacao-label {
    font: normal normal bold 14px/19px Open Sans;
    letter-spacing: 0;
    color: #333333;
    margin-bottom: 12px;
  }

  .tipo-solicitacao-box {
    border: 1px dashed #006FB966;
    border-radius: 10px;
    padding: 20px 15px;
  }

  .ms-radio {
    display: block;
    line-height: 26px;
  }
}
</style>
